import { callBackendApi } from "../axiosInstances/backendInstance/apiRequest";

export async function fetchMyAgenda(params = {}) {
  return callBackendApi("/agenda/me", "GET", null, { params });
}

export async function fetchUserAgenda(userId, params = {}) {
  return callBackendApi(`/agenda/users/${userId}`, "GET", null, { params });
}
